import React, { Component } from 'react'

class AddFaq extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: true,
      defaultQuestion: '',
      defaultAnswer: '',
      question: '',
      answer: ''
    }
  }

  _handleCancelClick () {
    this.setState({
      edit: false,
      question: this.state.defaultQuestion,
      answer: this.state.defaultAnswer
    })
    this.props.cancel()
  }

  _handleSaveClick () {
    const { question, answer } = this.state
    const data = {
      question,
      answer
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderFaqQuestion () {
    return <textarea rows="1" type="text" value={this.state.question} onChange={this._handleUpdateContent.bind(this, 'question')}></textarea>
  }
  _renderFaqAnswer () {
    return <textarea rows="1" type="text" value={this.state.answer} onChange={this._handleUpdateContent.bind(this, 'answer')}></textarea>
  }

  render () {
    return (
      <article className="faq">
        <div className="faq_inner flex column">
          <div className="contents flex question">
            <div className="faq_label">Q</div>
            { this._renderFaqQuestion()}
          </div>
          <div className="contents flex answer">
            <div className="faq_label">A</div>
            { this._renderFaqAnswer()}
          </div>
        </div>
        <div className="btn_group flex">
          <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>
          <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
        </div>
      </article>
    )
  }
}

export default AddFaq



// WEBPACK FOOTER //
// ./src/components/Properties/Faq/AddFaq.js